export const ANSWER_THEME_VARIANTS = {
  DEFAULT: 'default',
  WITHOUT_BACKGROUND: 'withoutBackground',
  SAND: 'sand',
} as const
